var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{style:({
      marginBottom: _vm.mainPadding.bottom,
      marginRight: _vm.mainPadding.right
    }),attrs:{"color":"deep-purple","dark":"","bottom":"","right":"","fixed":"","large":"","rounded":""},on:{"click":_vm.onClick}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("mdi-arrow-u-down-left-bold")]),_vm._v(" 通常モードに戻る ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }